export default __webpack_public_path__ + "static/media/Eternal Faith Belt.e3dd01be.jpg";